import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { 
  Container, 
  Table, 
  Modal,
  ModalBody,
  ModalHeader} from "reactstrap"

import "react-multi-carousel/lib/styles.css"

import { Link, useNavigate } from "react-router-dom"

import jwtDecode from "jwt-decode"
//i18n
import { withTranslation } from "react-i18next"
//pass request back end
import axios from "axios";
import moment from "moment";
import Loader from "react-spinner-loader";
import { GAMES_API_BASE_URL } from "../../../global";
const TimesTableReport = props => {


    //Dedoce user details start
    function decodeAccessToken(token) {
      try {
        const decoded = jwtDecode(token)
        return { success: true, data: decoded }
      } catch (error) {
        return { success: false, error: error.message }
      }
    }
  
    const [username, setusername] = useState(null)
  
    useEffect(() => {
      if (localStorage.getItem("authStudentUser")) {
        const obj = JSON.parse(localStorage.getItem("authStudentUser"))
        const jwtdecode = decodeAccessToken(obj)
  
       // console.log(jwtdecode.data)
  
        setusername(jwtdecode.data)
        //}
      }
    }, [props.success])

  const [loader, setLoader] = useState(false);
  
  const authUser = JSON.parse(localStorage.getItem('authStudentUser')) || null;

  const navigate = useNavigate();

   //Timetable game data start
    const [timeTableData, setTimeTableData] = useState([]);
     useEffect(() => {
      if (username) {
        fetchGamesData()
      }
    }, [username])
    const fetchGamesData = async () => {
      if (authUser && authUser != "" && authUser != null) {
        setLoader(true)
        try {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          const response = await axios.get(
            GAMES_API_BASE_URL + "timestable/api/standalone-results/by-student-key/"+username?.pk_student_key
          )
  
           if (response?.status === 200) {
              setLoader(false)
              const timestableData = response?.data?.data?.result || null;
              
              if(timestableData && timestableData.length > 0){
                setTimeTableData(timestableData || []);
                
              }else{
                setTimeTableData([]);
                
              }
              
            }
        } catch (error) {
          setLoader(false)
          //console.error("Error in fetchActivityLevelList:", error);
          // Handle errors appropriately
          if (error.response) {
            // Server responded with a status other than 2xx
            const errorMessages = error?.response?.data?.errors
              ? error?.response?.data?.errors.map(err => err.message).join("\n")
              : "An error occurred. Please try again.";
              toast.error(`Error: ${errorMessages}`, {
                autoClose: 3000, // 3 seconds
              });
            //alert(`Error: ${errorMessages}`);
          } else if (error.request) {
            // Request was made but no response received
            toast.error(`No response from server. Please check your internet connection.`, {
              autoClose: 3000, // 3 seconds
            });
          } else {
            // Other errors toast.error("Activity details not found! Please try again.", {
              
          }
        }
      } else {
        navigate("/login")
      }
    }
    //Timetable game data end
  const [modal_view_summary, setmodal_view_summary] = useState(false)
  const [viewSummaryData, setViewSummaryData] = useState([])
  const tog_view_summary = () => {
    setmodal_view_summary(!modal_view_summary)
  }

  const fetchSummaryData = async (id) => {
       if (authUser && authUser != "" && authUser != null) {
        try {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          const response = await axios.get(
            GAMES_API_BASE_URL + "timestable/api/standalone-attempts/by-session/"+id
          )
  
           if (response?.status === 200) {
              const summaryData = response?.data?.data?.attempts || null;
              
              if(summaryData && summaryData.length > 0){
                setViewSummaryData(summaryData || []);
                
              }else{
                setViewSummaryData([]);
                
              }
              
            }
        } catch (error) {
          //console.error("Error in fetchActivityLevelList:", error);
          // Handle errors appropriately
          if (error.response) {
            // Server responded with a status other than 2xx
            const errorMessages = error?.response?.data?.errors
              ? error?.response?.data?.errors.map(err => err.message).join("\n")
              : "An error occurred. Please try again.";
              toast.error(`Error: ${errorMessages}`, {
                autoClose: 3000, // 3 seconds
              });
            //alert(`Error: ${errorMessages}`);
          } else if (error.request) {
            // Request was made but no response received
            toast.error(`No response from server. Please check your internet connection.`, {
              autoClose: 3000, // 3 seconds
            });
          } else {
            // Other errors toast.error("Activity details not found! Please try again.", {
              
          }
        }
      } else {
        navigate("/login")
      }
    }
  const triggerSummary = async (id) => {
    fetchSummaryData(id)
    tog_view_summary()
  }
  const summaryStats = viewSummaryData?.reduce(
    (acc, item) => {
      acc.total += 1;
      if (item.isCorrect === true) acc.correct += 1;
      return acc;
    },
    { total: 0, correct: 0 }
  );

  const percentage = summaryStats.total > 0 
  ? ((summaryStats.correct / summaryStats.total) * 100).toFixed(1) 
  : "0.0";

return (
<React.Fragment>
<Loader
        show={loader}
        type="body"
      // stack="vertical"
      // message="Loading Data"
      />
  <Modal size="lg" isOpen={modal_view_summary} toggle={tog_view_summary} centered>
    <ModalHeader
      className="mt-0 p-0 pb-3 border-0"
      toggle={tog_view_summary}
    ></ModalHeader>
    <ModalBody className="p-0">
      <h2 className="text-center fw-bold mb-4">
        🏆 Summary
      </h2>
      <div className="d-flex justify-content-between">
        
      <h5 className=" fw-bold mb-2">
        Total Questions: {summaryStats.total}
      </h5>
      <h5 className=" fw-bold">
        Correct Answers: {summaryStats.correct}
      </h5>
      <h5 className="fw-bold">
        Accuracy: {percentage}%
      </h5>
      </div>
      

      <div className="">
        <div
          className="table-responsive mt-4"
        >
          <Table className="table custom-table noti-table">
            <thead>
              <tr>
                <th width="15%" className="text-center">
                  #
                </th>
                <th width="25%" className="text-center">
                  Question
                </th>
                <th width="15%" className="text-center">
                  Your Answer
                </th>
                <th width="15%" className="text-center">
                  Correct Answer
                </th>
                <th width="15%" className="text-center">
                  Result
                </th>
                <th width="15%" className="text-center">
                  Time (s)
                </th>
              </tr>
            </thead>
            <tbody>
              {viewSummaryData && viewSummaryData.length > 0 ? (
                viewSummaryData.map((item, index) => (
                  <tr key={index} className={item.isCorrect=== false ? "table-danger" : "table-success"}>
                    <td className="text-center">
                      {index + 1}
                    </td>
                    <td className="text-center">
                      {
                        item.questionA+' X '+ item.questionB
                      }
                    </td>
                    <td className="text-center">
                      {
                        item.userAnswer
                      }
                    </td>
                    <td className="text-center">
                      {item.isCorrect=== false ? (item.questionA * item.questionB) : '-'}
                    </td>
                    <td className="text-center">
                      {
                          item.isCorrect=== true ? 
                          (<i className="fas fa-check" style={{color:'#068954'}}></i>) 
                          : (<i className="mdi mdi-close-thick" style={{color:'#f23904'}}></i>)
                      }
                    </td>
                    <td className="text-center">
                      {
                          item.answerTimeSeconds
                      }
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <p className="font-size-15 opacity-50 text-center mb-0 py-1">
                      Data Not Found
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {/* <div className="d-block ">
                <p className="font-size-15 opacity-50 text-center mb-0 py-1">No Reports Found</p>
              </div> */}
        </div>
      </div>
    </ModalBody>
  </Modal>
  <div className="page-wrapper">
    <div className="cs-pg-header bg-dark-blue py-3 pb-5">
      <Container className="custom-wt">
        <div className="">
          <div className="mt-0">
            <Link className="text-white font-size-14" to={"/"}> {" "}
                  <span>
                    <i className=" fas fa-chevron-left me-1"></i>
            </span>{" "}
            BACK TO DASHBOARD
            </Link>
          </div>
          <div className="pg-title">Times Table Report</div>
        </div>
      </Container>
    </div>
    <Container className="custom-wt">

      <div className="page-inner_section mt-5 pt-2">
        <div className="pd-homework-section assessment-width-hold pb-100">
          <div className="page-header mb-4">

            {/* <div className="pg-info">
              <ul className="pg-tab list-unstyled mb-0 d-flex align-items-center">
                <li>SUBJECT</li>
                {subjectOptions.map((subject) => (// Map over each subject in subjectOptions 
                    <li
                      key={subject} // Set a unique key for each list item
                      className={selectedSubject === subject.subject_id ? "active" : ""} // Set class to "active" if selectedSubject matches the current subject 
                      onClick={() => handleSelectSubject(subject.subject_id)} // Set up click event handler to call handleSelectSubject with the current subject 
                    >
                      {selectedSubject === subject.subject_id && ( // Conditionally render a checkmark if selectedSubject matches the current subject 
                        <span>
                          <i className="fas fa-check"></i>
                        </span>
                      )} {" "} {subject.subject_name}
                    </li>
                  ))}
               
              </ul>
            </div> */}
          </div>
          <div className="hw-list mt-4">
            <ul className="list-unstyled mb-0">
              <li className="justify-content-between">
                {/* <p className="mb-0 text-uppercase luminous-wht">
                  <span className="text-warning fw-semibold font-size-12 me-1">{selectedSubjectName}</span>
                </p> */}
                <div className="d-flex align-items-start pb-4">
                  <div className="summary-child-left me-5">
                    <h3 className="bigger-ft mb-0">Times Table</h3>
                    <div className="font-size-16 fw-bold text-dark d-flex align-items-center gap-2 mt-0">
                      <span className="fw-light">For</span>{username
                    ? username.st_first_name
                      ? username.st_first_name + " " + username.st_surname
                      : ""
                    : ""}
                    </div>
                  </div>
                </div>
                <div className="horizontal-divider"></div>
                <div className="mst-ct1">
                  {/* <h4 className="mt-3 font-size-20 fw-bold text-dark mb-1">
                    🏆 Topics with High Mastery (More than 70)
                  </h4> */}
                  {/* <p className="font-size-18 mb-0">
                    You're a champion at these game! Keep up the good work.
                  </p> */}
                  <div className="table-responsive mt-4">
                    <Table className="table custom-table tb-custom-pd">
                      <thead>
                        <tr>
                          <th width="10%" className="text-center">
                            S.No
                          </th>
                          <th width="20%" className="text-center">Date/Time</th>
                          <th width="15%" className="text-center">Times Table</th>
                          <th width="15%" className="text-center">
                           Total Qns
                          </th>
                          <th width="15%" className="text-center">
                           Correct Ans
                          </th>
                          <th width="15%" className="text-center">
                            Accuracy(%)
                          </th>
                          <th width="10%" className="text-center">
                            VIEW
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                        timeTableData.length === 0 ? (
                          // Render a single row with "No data" if masryScoreData is empty
                          <tr>
                            <td colSpan="5" className="text-center font-size-18 fw-medium">No data yet</td>
                          </tr>
                        ) : (
                          // Render table rows if masryScoreData is not empty
                          timeTableData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                          .map((item, index) => (
                            <tr key={index}>
                              <td className="text-center font-size-18 fw-medium">{index + 1}</td>
                              <td className="font-size-18 fw-bold text-dark">{moment(item.createdAt).format('DD MMM YYYY hh:mm A')}</td>
                              <td className="text-center font-size-18 text-dark">x{item.tablesSelected}</td>
                              <td className="text-center font-size-18 text-dark">{item.totalQuestions}</td>
                              <td className="text-center font-size-18 text-dark">{item.score}</td>
                              <td className="text-center font-size-18 fw-bold text-dark">{((item.score / item.totalQuestions) * 100).toFixed(1)}</td>
                              <td className="text-center font-size-18 text-dark"><i className="mdi mdi-eye font-size-24" style={{ color: '#38a4f8' }} onClick={() => triggerSummary(item.sessionId)}></i></td>
                            </tr>
                          ))
                        )
                      }


                   
                      </tbody>
                    </Table>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Container>
  </div>
</React.Fragment>
)
}

TimesTableReport.propTypes = {
t: PropTypes.any,
}

export default withTranslation()(TimesTableReport)